import "./App.css";
import { ArcwareApplication, ArcwareConfig, ArcwareInit, PixelStreaming } from "@arcware-cloud/pixelstreaming-websdk";
import { log } from "console";
import React, { useState, useRef, useEffect } from "react";
import 'semantic-ui-css/semantic.min.css';
import { Button, Icon } from 'semantic-ui-react';
import "./assets/fonts/Intelligent Design - AvertaPE-Bold.otf"
import "./assets/fonts/Intelligent Design - AvertaPE-Regular.otf"


const App: React.FC = () => {
    const videoContainerRef = useRef<HTMLDivElement | null>(null);
    const [arcwareApplication, setArcwareApplication] = useState<any>(null);
    const [applicationResponse, setApplicationResponse] = useState<string>("");

    const handleSendCommand = (descriptor: Record<string, any>) => {
        arcwareApplication?.emitUIInteraction(descriptor);
    };


    //Get OS
    function getOS() {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    }

    function checkOS() {
        console.log("OS: " + getOS());
    }

    //Sets levelJSON
    let levelJson = {LoadLevels:'None'};
    function setLevelJson(tempName: string) {
        levelJson = {
            LoadLevels:tempName
        };
    }

    //Change for Web specific being Client or Default
    let webJson = { Webpage: 'Default' };
    function setWebJson(tempName: string) {
        webJson = {
            Webpage: tempName
        };
    }

    //Fullscreen functionality
    function requestFullScreen() {
        if (document.fullscreenElement) {
            document.body.requestFullscreen();
            document.exitFullscreen();
        }
        else {
            document.body.requestFullscreen();
        }
    }

    //Hide popup that show  when requested
    function hidePopup() {
        var popupContainer = document.getElementById("popup-container");
        var copyContainer = document.getElementById("copy-container");
        if (popupContainer) {
            popupContainer.style.display = "none";
        }
        if (copyContainer) {
            copyContainer.style.display = "none";
        }
    }

    const [showOverlay,setShowOverlay] = useState(true);

    function confirmEvent() {
        hidePopup();
    }

    function cancelEvent() {
        hidePopup();
    }

    const pixelStreamingRef = useRef<any>(null);

    useEffect(() => {
        const { Config, PixelStreaming, Application } = ArcwareInit(
            {
                shareId: "share-5fa7707a-87fe-40fc-b12b-aa12dcaefb57", // Leeds Fabric Works Replace with your actual Share ID
                //shareId: "share-d017d753-3c9c-487d-98f2-09fa4ecce746", // Lancaster Sail Works Replace with your actual Share ID
            },
            {
                initialSettings: {
                    StartVideoMuted: true,
                    AutoConnect: true,
                    AutoPlayVideo: true,
                },
                settings: {
                    infoButton: false,
                    micButton: false,
                    audioButton: false,
                    fullscreenButton: false,
                    settingsButton: false,
                    connectionStrengthIcon: false,
                },
            }
        );

        pixelStreamingRef.current = PixelStreaming;
        setArcwareApplication(Application);

        //Application.getApplicationResponse((response: string) =>
        //    setApplicationResponse(response)
        //);

        // Listen for messages from Unreal Engine
        Application.getApplicationResponse((response: string) => {
            console.log("Received from Unreal:", response);
            setApplicationResponse(response);


            if (response === '{"UEMessage":"StartLoad"}') {
                console.log("Loading Levles");
                const query = new URLSearchParams(window.location.search);
                const roomToken = query.get('room');
                const webToken = query.get('webpage');

                if (roomToken === null) {
                    console.log("CallNoneRoom");
                    setLevelJson('None');
                    PixelStreaming.emitUIInteraction(levelJson);
                }
                else {
                    console.log("CallingRoomDefault");
                    console.log("LoadLevels" + roomToken);
                    setLevelJson(roomToken);
                    PixelStreaming.emitUIInteraction(levelJson);
                }
                PixelStreaming.emitUIInteraction(webJson);

            }
            else if (response.includes('"LoadWebpage"')) {
                //Leeds Main Link
                var linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works?brands=all&utm_source=CODU%20website&utm_medium=referral&utm_campaign=The%20Fabric%20Works%20Docu&utm_content";
                //Lancaster Main Link
                //var linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works?brands=all&utm_source=CODU%20website&utm_medium=referral&utm_campaign=The%20Fabric%20Works%20Docu&utm_content=link";
                var header = document.getElementById("header-text");
                var popupContainer = document.getElementById("popup-container");
                var roomName = "";

                if (popupContainer) {

                    //Leeds The Fabric Works Rooms
                    if (response.includes('"Standard Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works?brands=all&utm_source=CODU%20website&utm_medium=referral&utm_campaign=The%20Fabric%20Works%20Docu&utm_content";
                        roomName = "Standard Studio";
                    }
                    else if (response.includes('"Classic Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/classic-studio-floors-1-5";
                        roomName = "Classic Studio";
                    }
                    else if (response.includes('"Classic Plus Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/classic-studio-floors-6-10";
                        roomName = "Classic Plus Studio";
                    }
                    else if (response.includes('"Premium Plus Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/premium-terrace-studio";
                        roomName = "Premium Plus Studio";
                    }
                    else if (response.includes('"Premium Top Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/premium-studio-top-floor";
                        roomName = "Premium Top Studio";
                    }
                    else if (response.includes('"Deluxe Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/superior-adaptable-studio-floors-1-5";
                        roomName = "Deluxe Studio";
                    }
                    else if (response.includes('"Deluxe Plus Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/superior-adaptable-studio-floors-6-10";
                        roomName = "Deluxe Plus Studio";
                    }
                    else if (response.includes('"Superior Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/superior-studio-floors-1-5";
                        roomName = "Superior Studio";
                    }
                    else if (response.includes('"Superior Plus Studio"')) {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works/superior-studio-floors-6-10";
                        roomName = "Superior Plus Studio";
                    }
                    else {
                        linkAddress = "https://prestigestudentliving.com/student-accommodation/leeds/the-fabric-works?brands=all&utm_source=CODU%20website&utm_medium=referral&utm_campaign=The%20Fabric%20Works%20Docu&utm_content";
                    }

                    //Lancaster The Sail Works Rooms
                    //if (response.includes('"Standard Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works?brands=all&utm_source=CODU%20website&utm_medium=referral&utm_campaign=The%20Fabric%20Works%20Docu&utm_content=link";
                    //    roomName = "Standard Studio";
                    //}
                    //else if (response.includes('"Classic Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works/classic-studio-floor-1-4";
                    //    roomName = "Classic Studio";
                    //}
                    //else if (response.includes('"Classic Plus Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works/classic-plus-studio-floor-5-7";
                    //    roomName = "Classic Plus Studio";
                    //}
                    //else if (response.includes('"Deluxe Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works/deluxe-studio";
                    //    roomName = "Deluxe Studio";
                    //}
                    //else if (response.includes('"Superior Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works/superior-studio-floor-1-4";
                    //    roomName = "Superior Studio";
                    //}
                    //else if (response.includes('"Superior Plus Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works/superior-studio-floor-5-7";
                    //    roomName = "Superior Plus Studio";
                    //}
                    //else if (response.includes('"Superior Plus with Terrace Studio"')) {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works/superior-plus-studio-with-terrace";
                    //    roomName = "Superior Plus with Terrace Studio";
                    //}
                    //else {
                    //    linkAddress = "https://prestigestudentliving.com/student-accommodation/lancaster/the-sail-works?brands=all&utm_source=CODU%20website&utm_medium=referral&utm_campaign=The%20Fabric%20Works%20Docu&utm_content=link";
                    //}

                    document.getElementById("redirect-button")?.setAttribute("href", linkAddress);
                    if (header) {
                        header.innerText = "To book and find out more about your selected room, please click 'continue' to visit prestigestudentliving.com.";
                    }
                    popupContainer.style.display = "flex";
                }
            }
            else if (response.includes('"RequestFullScreen"')) {
                requestFullScreen();
            }
            else {
                console.log("No matching command");
            }

        });

        // Append the application's root element to the video container ref
        if (videoContainerRef.current) {
            console.log("Appending Arcware video stream...");
            videoContainerRef.current.appendChild(Application.rootElement);
        }

        // Assuming you have your PixelStreaming of ArcwareInit at hand ...
        PixelStreaming.videoInitializedHandler.add(() => {
            // Wait for a short time to ensure everything is fully initialized
            setTimeout(() => {
                setShowOverlay(false);
            }, 1250); // Adjust the timeout duration as needed
        });

        return () => {
            // Cleanup function to remove the root element on unmount
            if (videoContainerRef.current && Application.rootElement) {
                videoContainerRef.current.removeChild(Application.rootElement);
            }
        };
    }, []);

    const handlePixelStreaming = () => {
        if (pixelStreamingRef.current) {
            pixelStreamingRef.current.connect();
        }
        else {
            console.warn("Streaming not ready");
        }
    }

    return (
        <div>

            {showOverlay && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "black", // Background color
                        zIndex: 9999, // Ensure it's on top of the video
                        cursor: "pointer", // Optional: give it a pointer cursor for feedback
                        display: "flex", // Enable flexbox
                        justifyContent: "center", // Center horizontally
                        alignItems: "center", // Center vertically
                        flexDirection: "column", // Stack items vertically
                    }}
                >
                    <div style={{ textAlign: "center" }}>
                         Image 
                        <img src="./CODU.png" alt="CODU Logo"
                            style={{
                            width: "60%", // Image width will be 80% of the parent container
                            maxWidth: "75px", // Ensure it doesn't stretch beyond original width
                            height: "auto", // Maintain aspect ratio
                            marginBottom: "10px", // Space between image and text
                            display: "block",
                            marginLeft:"auto",
                            marginRight:"auto"
                         }}></img>
                        {/*<button onClick={handlePixelStreaming}>Start Stream</button>*/}
                         Text underneath the image 
                        <p style={{ color: "white", fontSize: "45px", fontFamily: 'Bold' }}>Almost there...<br />You're going to love this.</p>
                        <p style={{ color: "white", fontSize: "20px", fontFamily: 'Regular' }}>Please wait while we load the content.</p>
                    </div>
                </div>
            )}

            <div ref={videoContainerRef} style={{ width: "100vw", height: "100vh" }} />

            {/*<button*/}
            {/*    style={{*/}
            {/*        position: "absolute",*/}
            {/*        right: "100px",*/}
            {/*        bottom: 20,*/}
            {/*        margin: "auto",*/}
            {/*        zIndex: 9,*/}
            {/*        width: "200px",*/}
            {/*    }}*/}
            {/*    onClick={checkOS}*/}
            {/*>*/}
            {/*    Emit command to Unreal*/}
            {/*</button>*/}

            {/*Fullscreen Button*/}
            {/*<button*/}
            {/*    //ref={buttonRef}*/}
            {/*    onClick={() => requestFullScreen()}*/}
            {/*    style={{ position: "absolute", top: "15%", left: "2%", width: "3%", height: "5%", background: "none", backgroundColor: "white", borderRadius: "5px", border: "none", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "2vh", pointerEvents: "auto" }}*/}
            {/*>*/}
            {/*    */}{/*className={isIPhone || handle.active || props.StreamerStatus !== StreamerStatus.Connected ? "hidden" : ""}*/}
            {/*    <img alt="expand-icon" src="./CODU Icons_Expand.png" style={{ width: "80%", height: "80%", objectFit: "contain" }}></img>*/}
            {/*</button>*/}

            {/*Video Wrapper */}
            {/*<div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "100%", background: "black", pointerEvents: "none" }} >*/}
            {/*    <div style={{ position: "relative", width: "100%", height:"100%"}}>*/}

            {/*        */}{/*Fullscreen Button*/}
            {/*        <button*/}
            {/*            //ref={buttonRef}*/}
            {/*            onClick={() => requestFullScreen()}*/}
            {/*            style={{ position: "absolute", top: "15%", left: "2%", width: "3%", height: "5%", background: "none", backgroundColor: "white", borderRadius: "5px", border: "none", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "2vh", pointerEvents: "auto" }}*/}
            {/*        >*/}
            {/*            */}{/*className={isIPhone || handle.active || props.StreamerStatus !== StreamerStatus.Connected ? "hidden" : ""}*/}
            {/*            <img alt="expand-icon" src="./CODU Icons_Expand.png" style={{ width: "80%", height: "80%", objectFit: "contain" }}></img>*/}
            {/*        </button>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="popup" id="popup-container">
                <div className="popcontent">
                    <h4 className="popup-header" id="header-text">This website will like to redirect you.</h4>
                    <Button className="ui blue button conbutton" onClick={confirmEvent} id="redirect-button" href="https://www.strive-group.com/" target="_blank">Confirm</Button>
                    <Button className="canbutton" onClick={cancelEvent}>Cancel</Button>
                </div>
            </div>
        </div>
    );
};

export default App;
